import { injectable } from "tsyringe";
import { IOTSimListLookupInjection } from "../../di/IOTSimListLookupInjection";
import { IOTSimListLookupListRequestEntity } from "../entities/IOTSimListLookupListRequestEntity";

@injectable()
export class IOTSimListLookupUseCase {
  private repo = IOTSimListLookupInjection.getIOTSimListLookupRepo();

  private checkParams(params: IOTSimListLookupListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  private buildFormData(params: IOTSimListLookupListRequestEntity): FormData {
    const formData = new FormData();
    if (params.file) formData.append("file", params.file);
    if (params.fileId) formData.append("fileId", params.fileId);
    if (params.trackingField) formData.append("trackingField", params.trackingField);
    if (params.page !== undefined) formData.append("page", String(params.page));
    if (params.limit !== undefined) formData.append("limit", String(params.limit));
    return formData;
  }

  async getIOTSimListLookupList(params: IOTSimListLookupListRequestEntity) {
    const processedParams = this.checkParams(params);
    const formData = this.buildFormData(processedParams);
    return this.repo.getList(formData);
  }

  async exportIOTSimListLookupExcel(params: IOTSimListLookupListRequestEntity) {
    const formData = this.buildFormData(params);
    return this.repo.exportExcel(formData);
  }

  async downloadIOTSimListLookupTemplate(params: IOTSimListLookupListRequestEntity) {
    return this.repo.downloadTemplate(params);
  }
}
